(function () {
'use strict';

angular
    .module('adminCACMRoutes', [
        'adminCACMControllers'
    ])
    .config(router);

router.$inject = ['$stateProvider'];

function router($stateProvider) {

    $stateProvider
            .state('admin.cacm', {
                url: '/CACM',
                views: {
                    'mainContent@admin': {
                        templateUrl: require('./adminCACM.tpl.html'),
                        controller: 'AdminCACMController'
                    }
                },
                data: {
                    permissions: { featureRole: 'CACMControlManagement', key: 'Indexing', permission: 'Manage' }
                }
            });
    }

})();